import {toValue} from "vue";
import {localizeLocation, type LocalizableLocation} from "~/utils/locale";


export const useLocalizedTo = (to: MaybeRefOrGetter<LocalizableLocation | undefined>) => {
  const  localeStore = useLocaleStore()
  // Rules (and the AB#63988 `{ path }` case) live on localizeLocation.
  const localizedTo = computed(() => localizeLocation(toValue(to), localeStore.subLocaleLang))

   return { localizedTo }
}
